const SidebarMenuItemTitle = ({ title, className = '' }) => (
  <span className={`menu-title ${className}`}>{title}</span>
)

export default SidebarMenuItemTitle
